import { ProductsTFunction } from '@retail/products/i18n';
import { ItemPriority } from '@retail/products/types';
import * as yup from 'yup';

const today = new Date();

export const addAssortmentItemSchema = (t: ProductsTFunction) =>
  yup.object({
    fromDate: yup
      .date()
      .required(t('products.mgItem.fromDate.validation.required'))
      .min(today, t('products.mgItem.fromDate.validation.min')),
    toDate: yup.date().nullable().optional().min(today),
    priority: yup.mixed<ItemPriority>().required(),
    isStocked: yup.boolean().required(),
    selectedSupplierId: yup.number().required(),
  });

export type AddAssortmentItemSchema = yup.InferType<ReturnType<typeof addAssortmentItemSchema>>;
